
/* styles */
require("!!../../../../../../../azure/movemais.client/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/style-rewriter?id=data-v-01f9e16a&scoped=true!sass-loader?sourceMap!./extract.scss")

var Component = require("!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/template-compiler?id=data-v-01f9e16a!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=template&index=0!./extract.vue"),
  /* scopeId */
  "data-v-01f9e16a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/pdf/extract.vue
// module id = 2032
// module chunks = 1